"use strict";
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMultiSelect = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
var models_1 = require("../../models");
require("./GKMultiSelect.css");
var GKMultiSelectDefinition = function (props, ref) {
    // Props!
    var bsSize = props.bsSize, children = props.children, className = props.className, data = props.data, qaProp = props["data-qa"], disabled = props.disabled, emptyTemplate = props.emptyTemplate, enforceMenuPlacement = props.enforceMenuPlacement, footerTemplate = props.footerTemplate, groupTemplate = props.groupTemplate, id = props.id, isOpen = props.isOpen, 
    // Intentionally destructured from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    itemTemplate = props.itemTemplate, _a = props.menuPlacement, menuPlacement = _a === void 0 ? "bottom-start" : _a, onBlur = props.onBlur, onChange = props.onChange, onMenuToggle = props.onMenuToggle, placeholder = props.placeholder, required = props.required, size = props.size, style = props.style, truncateSummary = props.truncateSummary, customSummary = props.customSummary, invalid = props.invalid, valid = props.valid, otherProps = __rest(props, ["bsSize", "children", "className", "data", "data-qa", "disabled", "emptyTemplate", "enforceMenuPlacement", "footerTemplate", "groupTemplate", "id", "isOpen", "itemTemplate", "menuPlacement", "onBlur", "onChange", "onMenuToggle", "placeholder", "required", "size", "style", "truncateSummary", "customSummary", "invalid", "valid"]);
    var groupCtx = React.useContext(components_1.GKFormGroupContext);
    // Refs
    var containerRef = React.useRef(null);
    // States
    var _b = React.useState([]), selection = _b[0], setSelection = _b[1];
    var _c = React.useState([]), normalizedData = _c[0], setNormalizedData = _c[1];
    var _d = React.useState(isOpen || false), openState = _d[0], setOpenState = _d[1];
    var isMobileSized = React.useContext(common_1.WindowSizeContext).isMobileSized;
    // Close the menu if the user takes an action outside the container.
    (0, hooks_1.useActionOutsideElement)(containerRef, function (shouldClose) {
        return openState && shouldClose && !isMobileSized && setOpenState(false);
    });
    // Build out classes for the select container (the outer container; mostly helper classes).
    var selectClasses = [];
    selectClasses.push(openState ? "menu-open" : "menu-closed");
    if (props.groupSelection !== undefined) {
        selectClasses.push("group-selection");
    }
    // Build out classes for the select box (our internal replacement for the select input).
    var selectBoxClasses = [
        "gk-multi-select-box",
        "d-flex",
        "align-items-center",
        "form-control",
    ];
    if (bsSize || size) {
        selectBoxClasses.push("form-control-" + (bsSize || size));
    }
    if (disabled) {
        selectBoxClasses.push("disabled");
    }
    if (valid && !invalid) {
        selectBoxClasses.push("border border-success");
    }
    if (invalid && !valid) {
        selectBoxClasses.push("border border-danger");
    }
    // Parse children into a data structure, to be passed to the selection menu
    var parseChildren = function (childrenToParse) {
        var parsed = [];
        React.Children.forEach(childrenToParse, function (child) {
            if (child.type === components_1.GKOption) {
                parsed.push([
                    child.props,
                    {
                        active: child.props.selected || false,
                        className: child.props.className,
                        "data-qa": child.props["data-qa"],
                        disabled: child.props.disabled || false,
                        onSelect: child.props.onSelect,
                        selectable: child.props.selectable === false ? false : true,
                        style: child.props.style,
                    },
                ]);
            }
            else if (child.type === components_1.GKOptgroup) {
                parsed.push(new models_1.Grouping(child.props.label, parseChildren(child.props.children), {
                    className: child.props.className,
                    "data-qa": child.props["data-qa"],
                    style: child.props.style,
                }));
            }
        });
        return parsed;
    };
    // Set all items as inactive.
    var clear = function () {
        var cleared = new models_1.Grouping("", normalizedData).mapChildren(function (child) {
            if ((0, components_1.isDatumWithMetadata)(child)) {
                child[1].active = false;
                return child;
            }
            else {
                return [child, { active: false }];
            }
        });
        setNormalizedData(cleared);
        setSelection([]);
    };
    // Handle the onChange event.
    var handleChange = function (selectedItems) {
        setSelection(selectedItems);
        if (onChange) {
            // If we have data, then we can pass back selected items as-is.
            if (data) {
                onChange(selectedItems);
            }
            // Otherwise we're using children. Assert it as option props and extract the value.
            else {
                onChange(selectedItems.map(function (item) { return item.value; }));
            }
        }
    };
    // Returns the "label", the strigified / short text of an item, used in the select box.
    var getLabelOfSelectedItem = function (item) {
        if (data) {
            return props.itemToString ? props.itemToString(item) : String(item);
        }
        var myItem = item;
        return myItem.label || myItem.children || null;
    };
    // Render the the text for the select box.
    var renderSummaryText = function () {
        var summaryText;
        if (selection.length) {
            if (truncateSummary) {
                summaryText = getLabelOfSelectedItem(selection[0]);
            }
            else {
                var labelElements = selection.map(getLabelOfSelectedItem);
                if (labelElements.every(function (i) { return typeof i === "string"; })) {
                    summaryText = labelElements.join(", ");
                }
                else {
                    summaryText = (React.createElement(React.Fragment, null, labelElements.map(function (item, index) {
                        return item
                            ? React.cloneElement(item, {
                                key: String(index),
                            })
                            : null;
                    })));
                }
            }
        }
        else {
            summaryText = placeholder;
        }
        return (React.createElement(React.Fragment, null, React.createElement(React.Fragment, null,
            React.createElement("div", { className: "gk-multi-select-box-text flex-shrink-1" }, customSummary ? customSummary(selection) : summaryText),
            !customSummary && selection.length > 1 && truncateSummary && (React.createElement("div", { className: "gk-multi-select-box-item-count ml-2" },
                "+",
                selection.length - 1)))));
    };
    // Override for the item template to insert checkboxes where needed.
    var itemTemplateOverride = function (item, meta) {
        var renderedItem;
        var selectable = true;
        if (data) {
            renderedItem = props.itemTemplate
                ? props.itemTemplate(item)
                : props.itemToString
                    ? props.itemToString(item)
                    : String(item);
            if (meta.selectable === false) {
                selectable = false;
            }
        }
        else {
            var castItem = item;
            renderedItem = React.createElement("span", null, castItem.children || castItem.label);
            if (castItem.selectable === false) {
                selectable = false;
            }
        }
        return (React.createElement("div", { className: "d-flex" },
            selectable && (React.createElement(components_1.GKCheckbox, { className: "gk-multi-select-option-checkbox mr-2", readOnly: true, checked: meta && meta.active })),
            renderedItem));
    };
    // Override for the group template to insert radio/checkboxes where needed.
    var groupTemplateOverride = function (group) {
        var renderedItem;
        var selector = React.createElement("span", null);
        if (data) {
            renderedItem = groupTemplate ? (groupTemplate(group)) : (React.createElement("span", null, group.groupName));
        }
        else {
            renderedItem = React.createElement("span", null, group.groupName);
        }
        if (props.groupSelection !== undefined) {
            if (props.groupSelection === "multi") {
                selector = (React.createElement(components_1.GKCheckbox, { readOnly: true, className: "gk-multi-select-group-checkbox mr-2", checked: group.metadata && group.metadata.active, indeterminate: group.metadata && group.metadata.indeterminate }));
            }
            else if (props.groupSelection === "single") {
                selector = (React.createElement(components_1.GKRadio, { readOnly: true, name: "gk-multi-select-group-radio", className: "gk-multi-select-group-radio mr-2", checked: group.metadata &&
                        (group.metadata.active || group.metadata.indeterminate) }));
            }
            return (React.createElement("div", { className: "d-flex align-items-center" },
                selector,
                renderedItem));
        }
        return renderedItem;
    };
    var toggle = function () {
        if (disabled) {
            return;
        }
        setOpenState(!openState);
    };
    // Handling keyup/click/blur events.
    var onKeyUp = function (event) {
        if (event.key === " ") {
            toggle();
        }
    };
    // Effects
    React.useEffect(function () {
        if (data) {
            setNormalizedData(data);
        }
        else {
            setNormalizedData(parseChildren(children));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children, data]);
    React.useEffect(function () {
        if (normalizedData.length) {
            var activeItems = normalizedData.length
                ? new models_1.Grouping("", normalizedData)
                    .flatten()
                    .filter(function (item) { return item[1] && item[1].active; })
                    .map(function (item) { return item[0]; })
                : [];
            setSelection(activeItems);
        }
    }, [normalizedData]);
    React.useEffect(function () {
        groupCtx.setDisabled(disabled);
    }, [groupCtx, disabled]);
    React.useEffect(function () {
        groupCtx.setValidation(invalid === true ? false : valid === true ? true : undefined);
    }, [groupCtx, invalid, valid]);
    React.useEffect(function () {
        groupCtx.setRequired(required);
    }, [groupCtx, required]);
    React.useImperativeHandle(ref, function () {
        var select = containerRef.current;
        if (!select) {
            return {};
        }
        return {
            clear: function () { return clear(); },
            close: function () { return setOpenState(false); },
            open: function () { return setOpenState(true); },
            toggle: function () { return toggle(); },
        };
    });
    // Render
    return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)({ className: className, id: id, style: style, "data-qa": qaProp }, {
        _gkComponentName: "gk-multi-select",
        className: selectClasses.join(" "),
    }), { ref: containerRef, tabIndex: disabled ? -1 : 0, onKeyUp: onKeyUp, onBlur: onBlur }),
        React.createElement("div", { className: selectBoxClasses.join(" "), onClick: toggle, "data-qa": qaProp ? qaProp + "--summary" : "gk-multi-select--summary" }, renderSummaryText()),
        normalizedData.length || (!normalizedData.length && emptyTemplate) ? (React.createElement(components_1.GKSelectionMenu, __assign({ anchorRef: containerRef, autoFocus: false, closeOnSelect: false, "data-qa": qaProp ? qaProp + "--menu" : "gk-multi-select--menu", emptyTemplate: emptyTemplate, enforcePlacement: enforceMenuPlacement, footerTemplate: footerTemplate, isOpen: openState, data: normalizedData, onChange: handleChange, onClose: function () { return setOpenState(false); }, onMenuToggle: onMenuToggle, selectMultiple: true, placement: menuPlacement, selection: selection, itemTemplate: itemTemplateOverride, groupTemplate: groupTemplateOverride }, otherProps, { ref: undefined }))) : null));
};
/**
 * Cross-browser compatible select box, which includes optgroups and selects. Renders a GKMenu,
 * making it visually compatible with several other components. GKMultiSelect should be used
 * whenever the user can make more than one selection. For single selects, use GKSelect.
 */
exports.GKMultiSelect = React.forwardRef(GKMultiSelectDefinition);
exports.default = exports.GKMultiSelect;
